import React, { Component } from "react";
import { Form, Row, Col } from "reactstrap";
import FormComponent from "../../../../common/FormComponent";
import {
  Validator,
  submitValidator,
  refresh,
  errors,
  valid,
} from "../../../../common/Validator";
import Notifier from "../../../aside/Notifier";
import ErrorNotifier from "../../../aside/ErrorNotifier";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import DateFns from "date-fns";
import Button from "@material-ui/core/Button";
import {withRouter} from 'react-router-dom'
import { getProfileInfo} from "../../../../redux/action/profileInfoAction"
import { connect } from "react-redux";
// import { KeyboardReturnTwoTone } from "@material-ui/icons";

/**
 * UpdateHonours Component for updating the honours details.
 */
class UpdateHonours extends Component {
  constructor(props) {
    super(props);

    this.state = {
      awardName: this.props.updateDataProp
        ? this.props.updateDataProp.awardName
        : "",
      dateAwarded: this.props.updateDataProp
        ?   DateFns.format(this.props.updateDataProp.dateAwarded, "YYYY-MM-DD") 
        : "",
      awardedBy: this.props.updateDataProp
        ? this.props.updateDataProp.awardedBy 
        : "",

      remark: this.props.updateDataProp
        ? this.props.updateDataProp.remarks
        : "",
      todateback: "",

      id: this.props.updateDataProp ? this.props.updateDataProp.id : "",
      toErrorYear:"",
      buttonAction:false,
      message: "",
      error: "",
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.dateToChange = this.dateToChange.bind(this);
   
  
  }

  // common onchange function

  onChange(e) {
    Validator(e.target);
    this.setState({
      [e.target.name]: e.target.value,
      buttonAction:false,
    });
  }

 


  // submit function by clicking submit button
  onSubmit(e) {
    e.preventDefault();
    console.log(this.state.fileUpload);

    submitValidator(e.target);

  
    let dateFrom =   DateFns.format( this.state.dateAwarded, "YYYY-MM-DD") 


    let data = {
      canInfoId:this.props.profile.data.id,
      awardName: this.state.awardName,
      dateAwarded: dateFrom,

      awardedBy: this.state.awardedBy,

      remarks: this.state.remark,
    };
    console.log(data);

    console.log(data);
    this.setState({
      buttonAction:true
    })
    if (valid  && !this.state.toErrorYear) {
      axios
        .post(
          `${API_CANDIDATE}/v1/api/can-award`,
          data,
          { withCredentials: true },
          {
            headers: {
              "Content-Type": "multipart/form-data; ",
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "successfully created",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  // onchange function for from date and to date

  dateToChange(e) {
    this.setState({
      buttonAction:false
    })
    let newdate = new Date(e.target.value);
    let dateTo = new Date(e.target.value);
    let dateYearTo = dateTo.getFullYear();

    if (
      dateYearTo.toString().length < 4 ||
      dateYearTo.toString().length > 4 ||
      dateYearTo > new Date(Date.now()).getFullYear()
    ) {
      this.setState({
        toErrorYear: "please enter valid date",
        dateError: "",
      });
    } else {
      this.setState({
        toErrorYear: "",
      });
    }

    this.setState({
      dateAwarded: e.target.value,
      todateback: newdate,
    });
    errors.dateAwarded=""
  }

  // update function by clicking update button

  onUpdate(e) {

    e.preventDefault();
    submitValidator(e.target);
    let dateFrom = DateFns.format( this.state.dateAwarded, "YYYY-MM-DD") 
    let data = {
      canInfoId:this.props.profile.data.id,
      id: this.state.id,
      awardName: this.state.awardName,
      dateAwarded:  dateFrom ,

      awardedBy: this.state.awardedBy,

      remarks: this.state.remark,
    };

    this.setState({
      buttonAction:true
    })
    if (valid && !this.state.toErrorYear) {
      axios
        .put(
          `${API_CANDIDATE}/v1/api/can-award`,
          data,
          { withCredentials: true },
          {}
        )
        .then((res) => {
          console.log(res);
          if (res.data.ok) {
            this.setState({
              message: "Updated successfully ",
            });
          }
          setTimeout(() => {
            this.setState({
              message: "",
            });
            this.props.back();
          }, 2000);
        })
        .catch((err) => {
          if (err.response &&!err.response.data.statusCode === 403) {
            this.setState({
              error:err.response.data.message
            })
              setTimeout(() => {
                this.setState({
                  error:""
                })
              }, 2000);
            } 
            else if (err.response && err.response.data.statusCode === 403) {
           this.setState({
            error:err.response.data.message
            })
             setTimeout(() => {
                this.setState({
                  error: "",
                });
            this.props.history.push("/signin");
               }, 2000);
            }
        });
    } else {
      this.setState({
        error: "Enter all mandatory fields",
      });
      setTimeout(() => {
        this.setState({
          error: "",
        });
      }, 2000);
    }
  }

  componentDidMount() {
    this.props.getProfileInfo()
    refresh();
    this.setState({
      message: "",
      error: "",
    });
  }

  render() {
    const { awardName, awardedBy, dateAwarded, remark, message, error } =
      this.state;

    return (
      <>
        {/* applied ternary operator for checking whether it is update or submit form */}
        {!this.props.updateDataProp ? (
          <div style={{ paddingLeft: "2.5rem" }}>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span>Honors And Awards</span>
              </div>
              <div>
                <Form onSubmit={this.onSubmit} className="p-3" noValidate>
                  <Row>
                    <Col md="6">
                      <FormComponent
                        index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Award Name"
                        type="textarea"
                        name="awardName"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={awardName}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                       index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Date Awarded"
                        type="date"
                        name="dateAwarded"
                        inputClass="form-control-sm"
                        value={dateAwarded}
                        change={this.dateToChange}
                        required={true}
                  
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                    </Col>
                    <Col md="6">
                      <FormComponent
                        index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Awarded By"
                        type="textarea"
                        minlength="2"
                        maxlength="60"
                        name="awardedBy"
                        inputClass="form-control-sm"
                        value={awardedBy}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Remarks"
                        type="textarea"
                        minlength="2"
                        maxlength="250"
                        name="remark"
                        inputClass="form-control-sm"
                        value={remark}
                        change={this.onChange}
                   
                     
                      />
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                     tabIndex="5"
                      disabled ={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Create
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        ) : (
          <div>
            <i
              className="material-icons cancel-button pointer"
              onClick={this.props.back}
            >
              cancel
            </i>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  paddingTop: "0.5rem",
                }}
              >
                <span>Honors And Awards</span>
              </div>
              <div>
                <Form onSubmit={this.onUpdate} className="p-3" noValidate>
                  <Row>
                    <Col>
                      <FormComponent
                       index="1"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Award Name"
                        type="textarea"
                        name="awardName"
                        minlength="2"
                        maxlength="60"
                        inputClass="form-control-sm"
                        value={awardName}
                        change={this.onChange}
                        required={true}
                      />
                      <FormComponent
                        index="3"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Date Awarded"
                        type="date"
                        name="dateAwarded"
                        inputClass="form-control-sm"
                        value={dateAwarded}
                        change={this.dateToChange}
                        required={true}
                     
                      />
                      <span style={{ color: "red", fontSize: "11px" }}>
                        {this.state.toErrorYear}
                      </span>
                    </Col>
                    <Col>
                      <FormComponent
                        index="2"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Awarded By"
                        minlength="2"
                        maxlength="60"
                        type="textarea"
                        name="awardedBy"
                        inputClass="form-control-sm"
                        value={awardedBy}
                        change={this.onChange}
                        required={true}
                      
                      />

                      <FormComponent
                        index="4"
                        style={{ height: "50px", marginTop: "10px" }}
                        labelClass="bold label-sm"
                        label="Remarks"
                        type="textarea"
                        minlength="2"
                        maxlength="250"
                        name="remark"
                        inputClass="form-control-sm"
                        value={remark}
                        change={this.onChange}
                      
                      />
                    </Col>
                  </Row>

                  <div className="center">
                    <Button
                      tabIndex="5"
                      disabled ={this.state.buttonAction}
                      type="submit"
                      style={{
                        background: "#0984e3",
                        marginTop: "30px",
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Update
                    </Button>
                  </div>
                </Form>

                {message && <Notifier message={message} />}
                {error && <ErrorNotifier message={error} />}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}



const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps,{getProfileInfo})(
  withRouter(UpdateHonours)
);

